import React, { useState, useEffect } from "react";
import { Icon, Step, Button } from "semantic-ui-react";

import { useStateValue } from "../../StateProvider";
import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import StepThree from "./StepThree";
import {checkAvailableService} from "../../reducer"
import "./styles/multiStepsBooking.css"
import BeanEasterLoadingBar from "../../images/BeanEater";
const MultiStepsBooking = (props) => {


  // User's selections
  const [selection, setSelection] = useState({
    service: {
      name: null,
      id: null,
    },
    date: new Date(),
    time: null,
    location: "Any Location",
  });

  // const [stepStatus,setStepStatus] = useState({active:true,disabled:false,incomplete:false})
  const [completedSteps, setCompletedSteps] = useState(1);
  const [numberOfSteps, setNumberOfSteps] = useState(3);
  const [stepDetail, setStepDetails] = useState([
    {
      iconName: "calendar",
      title: "Select Date/Location",
      description: "Choose your shipping options",
      id:1
    },
    {
      iconName: "tasks",
      title: "Choose a Service",
      description: "Enter billing information",
      id:2
    },
    {
      iconName: "info",
      title: "Confirm Order",
      description: "Review and confirm",
      id:3
    },
  ]);

  const serverDomain = process.env.REACT_APP_SERVER_URL;

  const [state, dispatch] = useStateValue();
  const{date,time,isAvailable,loading,error} = state



  useEffect(()=>{
   
if(date && time){
  dispatch({type:'call-api'});
  setTimeout(() => {
  const getServices = async ()=>{
    let datetime = formatDateTime();
   
      
    
    let response = await fetch(`${serverDomain}/availability`, {method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              date: datetime
            })
          }); 

          if(response.status === 200){
            let serviceDate = await response.json()
            let availableServices = checkAvailableService(serviceDate.services)
            // console.log("availableServices",availableServices);
            // console.log("serviceDate",serviceDate);
            dispatch({type:'success',data:serviceDate}) 
            if(availableServices.length > 0){
              dispatch({type:'ADD_AVAILABLE_SERVICES',available:availableServices,isAvailable:true})
            }else {

              dispatch({type:'ADD_AVAILABLE_SERVICES',available:[],isAvailable:false})
            }
            return;
          }
         dispatch({type:'error',error:await response.error})
  }
  getServices()
}, 5000);
  

}

  },[date,time])



  const formatDateTime = _ => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ];
    const TempDate =
      months[date.getMonth()] +
      " " +
      date.getDate() +
      " " +
      date.getFullYear();
    let TempTime = time.slice(0, -2);
    TempTime = TempTime > 12 ? TempTime  + ":00" : TempTime + ":00";
    const datetime = new Date(TempDate + " " + TempTime);
    // console.log("datetime",datetime)
    // console.log("dnew Date",new Date(datetime))
    return datetime;
  };

  const prev = ()=>{

    let step = completedSteps;
    if(step>1){
      step=step-1;
      setCompletedSteps(step);
    }
  }

  const next = ()=>{
let step = completedSteps;
if(step < numberOfSteps){
  step=step+1;
  setCompletedSteps(step);
}

  }


const setLastSetp =(step)=>{
  setCompletedSteps(step)
}

  return (
    <>
    <div
      style={{ gridColumn: "2", display: "flex", flexDirection: "column" }}
    >
      <Step.Group style={{padding:'1rem',marginTop:'1rem'}}>
        {stepDetail.map((step, i) => {
          let status = "";
          let currentStep = i+1
          if (currentStep < completedSteps) {
            status = "compeleted";
          }
          if (currentStep > completedSteps) {
            status = "disabled";
          }
          if (currentStep === completedSteps) {
            status = "active";
          }
          return (
            <Step key={currentStep} className={status === 'active'?"active":status==='compeleted'?"compeleted":status==='disabled'?"disabled":""}>
              <Icon name={step.iconName} />
              <Step.Content>
                <Step.Title>{step.title}</Step.Title>
                <Step.Description>{step.description}</Step.Description>
              </Step.Content>
            </Step>
          );
        })}
      </Step.Group>
<div style={completedSteps === 1 ?  {display: "grid",
alignContent: "center",
alignItems: "center",
gridTemplateRows: "minmax(150px,1fr) .5fr .5fr",
height: "100%"}:{display:"grid",height:"100%"} }>
{completedSteps === 1 && <StepOne />}
{completedSteps === 2 && <StepTwo step={completedSteps} setLastSetp={setLastSetp}/>}
{completedSteps === 3 && <StepThree setPage={props.setPage}/>}    
{completedSteps === 1&&loading?<div style={{display: "flex",
justifyContent: "center",
alignItems: "center",
gap: "1rem",
flexDirection: "column"}}><BeanEasterLoadingBar/><p>Just a moment!</p></div>:""}

{error?<div className="center">Error</div>:""}
{completedSteps === 1&&isAvailable ?<div className="center">Yay! Click next to see available Services</div>:(time&&date&&isAvailable ==false?<div className="center">Unfortunately No Availability , Please check different dates  </div>:"")}

<div className="center">
{completedSteps === 2 && <Button onClick={()=>{prev()}}>Change Dates</Button>}
{completedSteps === 1 && <Button disabled={isAvailable?false :true} onClick={()=>{next()}}>Next</Button>}

</div>
</div>
    </div>
    </>
  );
};
export default MultiStepsBooking